import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { Route, Routes, useLocation, useMatch } from "react-router-dom"

import Location from "./Location"
import Team from "./Team"
import RepositoryScreen from "../RepositoryScreen"
import { ScheduleButtonsAdmin } from "components"

import "./index.scss"

import { seatInfo, locations } from "state_management"
import useT from "utils/hooks/useT"

// Returns false if not customer admin
function getSeats(customers, companyId) {
  if (Object.keys(customers).length === 0) {
    return false
  }
  const c = customers[companyId]
  return { seatsPurchased: c.seatsPurchased, seatsTotal: c.seatsTotal, membersPlanners: c.membersPlanners, viewOnly: c.viewOnly }
}

export default function AdministratorScreen() {
  const dispatch = useDispatch()
  const { t } = useT("common")
  const companyName = useSelector((state) => state.auth.companyName)
  const { hasFetched, seatsPurchased, seatsTotal, membersPlanners, viewOnly } = useSelector((state) => state.seatInfo)
  const customers = useSelector((state) => state.customerAdministration.customers)
  const locationsData = useSelector((state) => state.locations)

  const companyId = useSelector((state) => state.auth.companyId)

  if (!hasFetched) {
    dispatch(seatInfo.fetch())
  }
  if (!locationsData) {
    dispatch(locations.fetch(companyId))
  }

  const location = useLocation()
  const locationMatch = useMatch("/locations/:locationId/teams")
  const activeLocationId = locationMatch?.params?.locationId
  const activeLocation = activeLocationId && locationsData?.find((loc) => loc.id === activeLocationId)

  // Show location-specific seats when viewing a location, otherwise company-wide
  const companySeats = getSeats(customers, companyId) || { seatsPurchased, seatsTotal, membersPlanners, viewOnly }
  const seats = activeLocation
    ? { seatsPurchased: companySeats.seatsPurchased, seatsTotal: activeLocation.seatsTotal, membersPlanners: activeLocation.membersPlanners, viewOnly: activeLocation.viewOnly }
    : companySeats

  const isRepositoryView = location.pathname.includes("/repository/")
  return (
    <div className="administrator-container">
      <ScheduleButtonsAdmin />
      {!isRepositoryView && (
        <div className="administrator-seats">
          <p className="seats">{t("purchasedSeats", { count: typeof seats.seatsPurchased === "number" ? seats.seatsPurchased : "..." })}</p>
          <p className="seats">{t("totalSeats", { count: typeof seats.seatsTotal === "number" ? seats.seatsTotal : "..." })}</p>
          <p className="seats">{t("membersPlanners", { count: typeof seats.membersPlanners === "number" ? seats.membersPlanners : "..." })}</p>
          <p className="seats">{t("viewOnlySeats", { count: typeof seats.viewOnly === "number" ? seats.viewOnly : "..." })}</p>
        </div>
      )}
      {!isRepositoryView && (
        <>
          <div className="company-headline">
            <h1>{companyName}</h1>
          </div>
        </>
      )}
      <div className="location-team-space">
        <Routes>
          <Route path="/" element={<Location />} />
          <Route path="/:locationId/teams" element={<Team />} />
          <Route path="/repository/:repositoryId" element={<RepositoryScreen />} />
        </Routes>
      </div>
    </div>
  )
}
